import { isArray } from './types'

export const unique = <T>(arr: T[]) => [...new Set(arr)]

export const extractFirst = <T>(arr: T | T[]): T => {
  return isArray(arr) ? arr[0] : arr
}

type Many<T> = T | ReadonlyArray<T>
// TODO: rename to `ensureArray`
/** like `_.castArray`, except falsy value returns empty array. */
export const castArray = <T>(arr: Many<T>): T[] => {
  if (!arr && (arr as any) !== 0) return []
  return isArray(arr) ? arr : [arr as T]
}

// TODO: remove import alias
// avoid naming conflicts
export { castArray as ensureArray } from 'lodash-unified'
